'use client';

import { useCallback } from 'react';
import { terraProxyApiClient } from '../../clients/testerClient';
import { rehydrateAfterFailedSubagentAbort } from '../../hooks/useBackgroundSubagentLifecycle';
import { resolveSubagentAbortBind } from '../../utils/subagentAbortBind';
import {
  useBackgroundExecutionStore,
  type PendingBackgroundExecution,
} from '../../store/backgroundExecutionStore';

export function useAbortSubagentExecution({
  chatId,
  targetId,
  targetType,
}: {
  chatId: string;
  targetId?: string;
  targetType?: string;
}): (execution: PendingBackgroundExecution) => void {
  return useCallback(
    (execution: PendingBackgroundExecution) => {
      void terraProxyApiClient
        .abortSubagent({
          threadId: chatId,
          ...resolveSubagentAbortBind({
            execution,
            currentTarget: { targetId, targetType },
          }),
          toolCallId: execution.toolCallId,
        })
        .then(() => {
          const store = useBackgroundExecutionStore.getState();

          if (!store.getPendingExecution(execution.toolCallId)) {
            store.setPendingExecution({
              ...execution,
              terminalStatus: 'aborted',
            });

            return;
          }

          store.markSubagentTerminal({
            agentThreadId: execution.agentThreadId,
            toolCallId: execution.toolCallId,
            terminalStatus: 'aborted',
          });
        })
        .catch((error: unknown) => {
          rehydrateAfterFailedSubagentAbort({ chatId, error });
        });
    },
    [chatId, targetId, targetType],
  );
}
